import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    manufacturerPartyId: Yup.string().nullable(),
    htsNo: Yup.string().matches(/^[0-9\-]+$/, "Please enter only numeric(without spaces)").required(requiredMessage).nullable(),
    countryOrigin: Yup.string().nullable(),
  })
}

export default makeValidationSchema
